export default __webpack_public_path__ + "static/media/SKS_History.e6bee54d.svg";